import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Appointment } from '../../core/models';

@Injectable({
  providedIn: 'root'
})
export class AppointmentEventService {
  private appointmentSavedSource = new Subject<Appointment>();
  private appointmentUpdatedSource = new Subject<Appointment>();
  private appointmentDeletedSource = new Subject<Appointment>();

  appointmentSaved$: Observable<Appointment> = this.appointmentSavedSource.asObservable();
  appointmentUpdated$: Observable<Appointment> = this.appointmentUpdatedSource.asObservable();
  appointmentDeleted$: Observable<Appointment> = this.appointmentDeletedSource.asObservable();

  constructor() { }

  // Methods to emit events
  emitAppointmentSaved(appointment: Appointment): void {
    this.appointmentSavedSource.next(appointment);
  }

  emitAppointmentUpdated(appointment: Appointment): void {
    this.appointmentUpdatedSource.next(appointment);
  }

  emitAppointmentDeleted(appointment: Appointment): void {
    this.appointmentDeletedSource.next(appointment);
  }
}
